import { css } from "@emotion/react";

import { blue, greyDark, greySecondary } from "../../styles/variables";

export const blueGreyGradientBackground = css`
  background-image: linear-gradient(to right, ${blue}, ${greySecondary});
`;
export const blueBackground = css`
  background-color: ${blue};
`;

export const greyText = css`
  color: ${greyDark};
`;

export const blueText = css`
  color: ${blue};
`;

const row = css`
  display: flex;
  flex-direction: row;
`;

export const lineContainer = css`
  ${row}
  div:not(:first-of-type) {
    margin-left: 4px;
  }

  padding: 0 40px;
`;

export const labelContainer = css`
  ${row}
  div:not(:first-of-type) {
    margin-left: 16px;
  }
`;

export const stepperContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const line = css`
  width: 91px;
  height: 6px;
  margin-bottom: 8px;
  background-color: ${greySecondary};
`;

export const label = css`
  width: 78px;
  text-align: center;
`;
